export enum RECEPTOR_MODEL_IDS {
  ANECDOTES = 'trr-anecdotes',
  ARCHER = 'trr-archer',
  CONFLUENCE = 'trr-confluence-dms',
  SHAREPOINT = 'trr-sharepoint',
  JIRA_WORKFLOW = 'trr-jira-workflow',
  SNOW_WORKFLOW = 'trr-servicenow-workflow',
}
